export enum PAYMENT_TYPE_ID {
    CASH = 1,
    CHANNEL_ACCOUNT = 2,
    CUSTOMER_ACCOUNT = 3,
    PROMPTPAY = 4,
    GIFTCARD = 5,
    CREDITCARD = 6,
    EVO_PAYMENT = 7,
    // UI Payment type
    TIPS = 99,
}

export const PAYMENT_PAID_ERROR = 'Sale is paid.'
export const TRANSACTION_PROCESSED_ERROR =
    'The transaction is already processed'
